export default "__VITE_ASSET__BjHuxjW0__"